import { render, staticRenderFns } from "./ChatConversationList.vue?vue&type=template&id=8d7a671c&scoped=true"
import script from "./ChatConversationList.vue?vue&type=script&lang=js"
export * from "./ChatConversationList.vue?vue&type=script&lang=js"
import style0 from "./ChatConversationList.vue?vue&type=style&index=0&id=8d7a671c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7a671c",
  null
  
)

export default component.exports